import React from 'react';
import PropTypes from 'prop-types';

import Loading from '../../../../shared/loading';
import ErrorBoundary from '../../../../shared/error-boundary';
import defaultOnErrorHandler from '../../../../shared/default-on-error-handler';
import {
  updateRegUserRestrictions,
} from '../../../../services/wire/edit-event-restrictions-services';

export default class RestrictionsUserControl extends React.Component {
  static propTypes = {
    wireId: PropTypes.number.isRequired,
    wasRestrictedToRegisteredUsers: PropTypes.bool.isRequired,
  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      isRestricted: this.props.wasRestrictedToRegisteredUsers,
    };
  }

  handleIsRestrictedToRegisteredUsersChange(evt) {
    const isRestricted = evt.target.value === 'true';

    this.loading.start();
    updateRegUserRestrictions(this.props.wireId, isRestricted)
      .then(() => this.setState({ isRestricted }))
      .catch(e => defaultOnErrorHandler(e, 'Error updating is restricted to registered users'))
      .finally(() => this.loading.stop());
  }

  render() {
    return (
      <ErrorBoundary>
        <aside className="sidebar-item">
          <form className="--user-facing">
            <section className="form-group">
              <span className="sidebar-item-desc">Restrict wire to registered users?</span>
              <label htmlFor="redirect-yes" className="sidebar-item-radio-group">
                <input
                  id="redirect-yes"
                  type="radio"
                  value
                  checked={this.state.isRestricted}
                  onChange={e => this.handleIsRestrictedToRegisteredUsersChange(e)}
                />
                Yes
              </label>
              <label htmlFor="redirect-no" className="sidebar-item-radio-group">
                <input
                  id="redirect-no"
                  type="radio"
                  value={false}
                  checked={!this.state.isRestricted}
                  onChange={e => this.handleIsRestrictedToRegisteredUsersChange(e)}
                />
                No
              </label>
              <Loading variant="sip" ref={el => (this.loading = el)} />
            </section>
          </form>
        </aside>
      </ErrorBoundary>
    );
  }
}
